import React from 'react';
import parse from 'html-react-parser';

import styles from './editor-content-display.module.css';

interface EditorProps {
    content?: string;
}

export const EditorContentDisplay: React.FC<EditorProps> = ({ content }) => (
    <div className={`${styles.Content} ck-content`}>{!!content ? parse(content) : ''}</div>
);
